import React, { Component } from 'react';
import { Status } from '~/Api/DataSourceStatus';
import config from '~/config';
import Detail from '~/DataSourceStatus/Detail/Detail';
import ActivityIndicator from '~/UI/ActivityIndicator';
import Heading from '~/UI/Heading/Heading';

import styles from './styles.less';

interface Props {
	statuses: Status[] | null;
	isFetching: boolean;
	onFetch(): void;
}

export default class StatusesPage extends Component<Props> {
	componentDidMount() {
		this.props.onFetch();
	}

	render() {
		const { statuses, isFetching } = this.props;

		return (
			<section className={styles.section}>
				<div className={styles.header}>
					<div className={styles.in}>
						<Heading>Datasources status</Heading>
						<p className={styles.perex}>
							This dashboard provides information about the last update of datasources integrated with the COGVIO Price
							monitor. For additional information or to report a&nbsp;problem, please contact{' '}
							<a href={`mailto:${config.support.email}`}>{config.support.email}</a>.
						</p>
						<p className={styles.perex}>
							Cogvio is transparently providing the same data as in the source and is not liable for the data
							complexity, accuracy and quality obtained from third parties.
						</p>
						<p className={styles.perex}>Price Monitor extracts data from the following data sources:</p>
					</div>
				</div>
				<div className={styles.in}>
					<div className={styles.datasetSourceList}>
						{isFetching ? <ActivityIndicator /> : null}

						{statuses
							? statuses.map((status) => (
									<Detail key={`${status.dataSource.country.alpha2}-${status.dataSource.type}`} status={status} />
							  ))
							: null}
					</div>
				</div>
			</section>
		);
	}
}
